//this houses the logic for prepping data to be handed off to the parent view.
define(function (require) {
	const CN = require('civicsUtils/constants');
	//site types
	const address = 'address';
	const parcel = 'parcel';
	const asset = 'asset';
	const property = 'property';
	
	return {
		processLocationData: function(locationText){
			let data = {
				location:locationText,
				hasPrimarySite:false, 
				address:{id:1},//by setting these defaults, we prevent submitting multiple primary sites, for instance when switching site type after a clone.
				asset:{id:1},
				parcel:{id:1},
				Spatial:{}		
			};
			
			//.where returns an array, not a collection.
			let selectedProperties = [];//all sites, for display only on review/confirmation
			let associatedProperties = [];//only associated sites (not to include primary site)
			
			let primary = this.selectedSitesCollection.where({primarySite:true});
			let associatedSitesModelArray = this.selectedSitesCollection.where({primarySite:false});

			if(primary.length > 0){
				let primaryJSON = primary[0].toJSON();
				primaryJSON.id = this.getIDofSite(primaryJSON, true);
				primary[0].get('_siteType') === "coords" ? data.Spatial = primaryJSON.Spatial : data[primary[0].get('_siteType')] = primaryJSON;
				//data[primary[0].get('_siteType')] = primaryJSON;
				if(primary[0].get('_siteType') === "coords"){
					primaryJSON.lat = data.Spatial.yCoordinate;
					primaryJSON.lon = data.Spatial.xCoordinate;

				}
				selectedProperties.push(primaryJSON);
				data.hasPrimarySite = true;
			}
			//set to true if we have location details populated.
			if(data.hasPrimarySite == false && data.location!=null && data.location.trim().length>0){
				data.hasPrimarySite = true;
			}
			associatedSitesModelArray.forEach((site)=>{
				let siteJSON = site.toJSON();
				selectedProperties.push(siteJSON);
				associatedProperties.push(this.processAssociatedSite(siteJSON));
				
			})
			data.associatedProperties = associatedProperties;
			data.selectedProperties = selectedProperties;

			return data;
		},
		/*
		for associated properties, the data is expected like so:
		[{
			address:123
		},
		{
			parcel:321
		},
		{
			asset:{
				id:1234
			}
		}]
		Kinda awkward at the moment, but when support is added for building floors, 
		or roadways, we'll need the asset to be an object anyways
		*/
		processAssociatedSite:function(site){
			let ret = {};
			ret[site._siteType] = site._siteType == asset ? {id:this.getIDofSite(site)} : this.getIDofSite(site);//the actual ID of the site... address: for address, parcel: for parcel, etc
			ret.siteInfo = site;
			ret.siteType = CN.SITE_TYPE_FOR_APPLICATION_ASSOCIATION[site._siteType.toUpperCase()];//1-address, 2-parcel, 4-asset
			return ret;
		},
		getIDofSite:function(site, isPrimary = false){
			let ret = site[site._siteType];
			if(ret == undefined){//depending on how we get the site, the ID may have a prefix on it. so we grab the REAL ID off of the site by accessing the parameter matching it's site type.
				ret = site.id;//but in some cases, the ID hasn't been touched and we can just grab it.
			}
			if(site._siteType == asset){
				ret = site.asset && site.asset.id? site.asset.id : site.id;
			}
			return ret;
		},
	}
});